// Indian formatting helpers
export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Math.round(Number(n)));
};

// DD-MM-YYYY
export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = d.getFullYear();
    return `${dd}-${mm}-${yy}`;
  } catch {
    return iso;
  }
};

// HH:MM (24h) — input "09:00" or ISO datetime
export const formatTime24 = (s) => {
  if (!s) return "—";
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  try {
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return `${String(d.getHours()).padStart(2, "0")}:${String(
      d.getMinutes()
    ).padStart(2, "0")}`;
  } catch {
    return s;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  return `${formatDate(iso)} ${formatTime24(iso)}`;
};

// HTML date input expects YYYY-MM-DD
export const toInputDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (!isNaN(d.getTime())) return d.toISOString().slice(0, 10);
    // Fallback 1: if string already looks like YYYY-MM-DD with valid month, return as-is
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (m) {
      const [, y, mm, dd] = m;
      const mi = Number(mm), di = Number(dd);
      // Detect swapped DD-MM-YYYY-as-YYYY-DD-MM (e.g. "1990-18-05" means 18/05/1990)
      if (mi > 12 && di <= 12) {
        return `${y}-${dd.padStart(2, "0")}-${mm.padStart(2, "0")}`;
      }
      if (mi >= 1 && mi <= 12 && di >= 1 && di <= 31) return iso;
    }
    return "";
  } catch {
    return "";
  }
};
